import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { IMG_BASE_URL, WEB_DOMAIN_KEY } from '../../../config/Config'
import Footer from '../../common/footer/Footer'
import Header from '../../common/header/Header'
import { get_Page_Seo } from '../../../api/global/Global'
import Loader from '../../../loader/Loader'
import { Helmet } from 'react-helmet'
import parse from 'html-react-parser';
import { fetchHomeData } from '../../../redux/actions/homedataAction'
import { useDispatch, useSelector } from 'react-redux'

const All_Letest_Post = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const { homeData, isLoading } = useSelector(
        (state) => state?.homedata || {}
    );
    const [is_loading, set_Is_Loading] = useState(isLoading || false)
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSeo, set_Page_Seo] = useState({})

    const productsPerPage = 12;
    const totalPages = Math.ceil(homeData?.blog?.length / productsPerPage) || 1;
    const startIndex = (currentPage - 1) * productsPerPage;
    const currentProduct = homeData?.blog?.slice(startIndex, startIndex + productsPerPage) || [];

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePrev = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };


    useEffect(() => {
        dispatch(fetchHomeData());
    }, [dispatch]);

    useEffect(() => {
        const Get_Page_Seo = async () => {
            set_Is_Loading(true);
            try {
                const response = await get_Page_Seo()
                if (response?.data?.status == 200) {
                    const seo = response?.data?.data?.seo
                    const filterSeoPage = seo?.find(page => page?.page_name === "Blogs")
                    set_Page_Seo(filterSeoPage)
                }
            } catch (error) {
                console.error(error)
            } finally {
                set_Is_Loading(false);
            }
        }
        Get_Page_Seo()
    }, [])

    // Scroll to the top of the page when the component is rendered
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            {/*  */}
            {
                is_loading ? (
                    <Loader />
                ) : (
                    <>
                        <Helmet>
                            <title>{pageSeo?.meta_title}</title>
                            <meta name="description" content={pageSeo?.meta_description} />
                            <link rel="canonical" href={`${WEB_DOMAIN_KEY}blogs`} />
                            <link rel="alternate" hreflang="en-us" href={`${WEB_DOMAIN_KEY}blogs`} />
                        </Helmet>
                        {/*  */}
                        <Header />
                        <section className='banner-section'>
                            <div className={`${pageSeo?.image ? "block" : "hidden"} relative`}>
                                <img src={`${IMG_BASE_URL}${pageSeo?.image}`} alt={pageSeo?.alt
                                } className='w-full h-auto object-cover' />
                            </div>
                        </section>
                        <section className="gi-blog-section py-[40px] max-[767px]:py-[30px] wow fadeInUp">
                            <div
                                className="flex flex-wrap justify-between items-center mx-auto min-[1400px]:max-w-[1200px] min-[1200px]:max-w-[1140px] min-[992px]:max-w-[960px] min-[768px]:max-w-[720px] min-[576px]:max-w-[540px]">
                                <div className="w-full flex flex-wrap mb-[-24px]">
                                    <div className="section-title w-full mb-[20px] pb-[20px] flex justify-between pb-[20px] z-[5] max-[575px]:flex-col px-[12px]">
                                        <div className="section-detail">
                                            <h1
                                                className="gi-title mb-[0] text-[25px] font-semibold text-[#4b5966] relative inline p-[0] capitalize leading-[1] font-Poppins max-[991px]:text-[24px] max-[767px]:text-[22px] max-[575px]:text-[20px]">
                                                Latest <span className="text-[#9F2225]">Posts</span></h1>
                                            <p className="max-w-[400px] mt-[10px] text-[14px] text-[#777] leading-[18px]">Explore our award
                                                winning blogs</p>
                                        </div>
                                    </div>
                                    <div className="grid gap-6 grid-cols-1 md:grid-cols-3 lg:grid-cols-4 px-[12px]">
                                        {
                                            currentProduct?.map((letest_blog_result) => {
                                                return (
                                                    <div onClick={() => localStorage.setItem("letest_blog_result_id", letest_blog_result?.id)}>
                                                        <Link to={`/blog/${letest_blog_result?.slug}`}>
                                                            <div className="gi-blog-item">
                                                                <div
                                                                    className="blog-info transition-all duration-[0.3s] ease-in-out w-full mb-[24px] hover:shadow-lg shadow-custome rounded-[5px]">
                                                                    <figure className="blog-img w-full h-auto m-[0] relative overflow-hidden rounded-[5px]">
                                                                        <img src={`${IMG_BASE_URL}${letest_blog_result?.image}`} alt={letest_blog_result?.alt_image_title}
                                                                            className="transition-all duration-[0.3s] ease-in-out rounded-[5px] h-56 w-96 object-fill" />
                                                                    </figure>
                                                                    <div className="detail p-3 w-full m-[0]">

                                                                        <h2 className=" p-[0] font-Poppins text-[#4b5966] text-[17px] font-medium leading-[22px] line-clamp-1">{letest_blog_result?.title}</h2>
                                                                        <label className=" text-[#999] hover:text-[#5caf90] inline-block text-[13px]">Author - {letest_blog_result?.author_name}</label>
                                                                        <div className="more-info mt-[8px]">
                                                                            <span className="transition-all duration-[0.3s] ease-in-out text-[#DE9553] text-[13px] flex items-center hover:text-[#9F2225]">Read
                                                                                More<i className="fi-rr-angle-double-small-right transition-all duration-[0.3s] ease-in-out ml-[5px] text-[#DE9553] text-[13px] flex"></i></span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {/* <!-- Pagination Start --> */}
                                    <div className="gi-pro-pagination pt-[15px] pb-[15px] flex justify-between items-center border-t-[1px] border-solid border-[#eee] max-[575px]:flex-col w-full">
                                        <span className="text-[14px] text-[#777] max-[575px]:mb-[10px]">Showing {startIndex + 1}-{Math.min(startIndex + productsPerPage, currentProduct?.length)} of {currentProduct?.length} Product(s)</span>
                                        <ul className="gi-pro-pagination-inner flex">
                                            {currentPage > 1 && (
                                                <li>
                                                    <button
                                                        onClick={handlePrev}
                                                        className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                    >
                                                        Prev
                                                    </button>
                                                </li>
                                            )}
                                            {[...Array(totalPages).keys()].map((page) => (
                                                <li key={page} className="inline-block float-left mr-[5px]">
                                                    <button
                                                        onClick={() => handlePageChange(page + 1)}
                                                        className={`transition-all duration-[0.3s] m-1 p-2 ease-in-out w-[32px] h-[32px] font-light 
                text-[#777] leading-[32px] bg-[#eee] flex text-center align-top 
                text-[16px] justify-center items-center rounded-[5px]
                ${currentPage === page + 1 ? 'active bg-red-500 text-white' : 'bg-gray-300 text-white'}`}
                                                    >
                                                        {page + 1}
                                                    </button>
                                                </li>
                                            ))}
                                            {currentPage < totalPages && (
                                                <li>
                                                    <button
                                                        onClick={handleNext}
                                                        className="next w-auto px-[13px] text-[#fff] m-1 p-2 bg-[#5caf90] leading-[30px] h-[32px] bg-red-500 flex text-center align-top text-[16px] justify-center items-center rounded-[5px]"
                                                    >
                                                        Next
                                                    </button>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                    <div className="sub__title text-gray-900 mt-3">{pageSeo?.description && parse(pageSeo?.description)}</div>
                                </div>
                            </div>
                        </section>
                        <Footer />
                    </>
                )
            }
            {/*  */}
        </div>
    )
}

export default All_Letest_Post